import _ from 'lodash';
import { DataFilesService } from './DataFilesService';

export class CardsService extends DataFilesService {

  get name() { return 'cards'; }

}

export const hooks = {
  before  : { all : [ 'auth' ] },
};
